import { NextAxios as http } from '@/utils/request';
import host from '@/utils/request/host';

export function timeApi() {
  return http.get<number>(`${host.admin}/common/sys/time`, {}, { noSign: true });
}
